/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { IoIosArrowBack, IoMdSend } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import { showToast } from "../../showTost";
import { socket } from "../../socket";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";

const mergeChatData = (prev, newBlocks) => {
  const merged = [...prev];
  for (const newBlock of newBlocks) {
    const existingIndex = merged.findIndex((b) => b.date === newBlock.date);
    if (existingIndex !== -1) {
      merged[existingIndex] = {
        ...merged[existingIndex],
        chat: [...merged[existingIndex].chat, ...newBlock.chat],
      };
    } else {
      merged.push(newBlock);
    }
  }
  return merged;
};

const Chat = ({ index, setShowChat, doctorId }) => {
  const { t } = useTranslation();

  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [user, setUser] = useState();
  const [input, setInput] = useState("");
  const [chatData, setChatData] = useState([]);
  const [chatUser, setChatUser] = useState([]);
  const [selectUser, setSelectUser] = useState();
  const [loading, setLoading] = useState(true);
  const [isShow, setIsShow] = useState(false);
  const [search, setSearch] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [apiloading, setApiLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [lastScrollTop, setLastScrollTop] = useState("");
  const [hasMore, setHasMore] = useState(true);

  const chatBoxBodyRef = useRef(null);
  const NoMoreDataRef = useRef(true);
  const ClassRef = useRef();
  const shouldScrollToBottomRef = useRef(false);
  const prevScrollHeightRef = useRef(0);
  const [isOnline, setIsOnline] = useState(false);
  const [partnerTyping, setPartnerTyping] = useState(false);
  const typingTimeoutRef = useRef(null);
  const amTypingRef = useRef(false);

  useEffect(() => {
    if (shouldScrollToBottomRef.current && chatBoxBodyRef.current) {
      const container = chatBoxBodyRef.current;
      setTimeout(() => {
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      }, 50);
      shouldScrollToBottomRef.current = false; 
    } else if (prevScrollHeightRef.current > 0 && chatBoxBodyRef.current) {
      const container = chatBoxBodyRef.current;
      const diff = container.scrollHeight - prevScrollHeightRef.current;
      if (diff > 0) {
        container.scrollTop = diff;
      }
      prevScrollHeightRef.current = 0;
    }
  }, [chatData]);

  useEffect(() => {
    if (doctorId) {
      sessionStorage.setItem("Selectid", String(doctorId));
      setHasMore(true);
      NoMoreDataRef.current = true;
      shouldScrollToBottomRef.current = true;

      if (page === 1) {
        handleGetMessage(1);
      } else {
        setPage(1);
      }
    }
  }, [doctorId]);

  const handleGetMessage = (page) => {
    const Userid = secureLocalStorage.getItem("Userid");
    const RecevierId = selectUser
      ? (Userid === Number(selectUser?.sender_id) ? selectUser?.receiver_id : selectUser?.sender_id)
      : doctorId;

    if (RecevierId && Userid) {
      if (page === 1) {
        setApiLoading(true);
      }

      const Data = {
        id: Userid,
        sender_id: Userid,
        recevier_id: RecevierId,
        status: "customer",
        page,
      };

      axios
        .post(`${ApiBaseUrl}/chat/user_to_user_chat_list`, Data)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            const AllChat = res.data.all_chat;
            if (AllChat.length === 0) NoMoreDataRef.current = false;
            if (page === 1) {
              shouldScrollToBottomRef.current = true;
              setChatData(AllChat);
            } else {
              if (chatBoxBodyRef.current) {
                prevScrollHeightRef.current = chatBoxBodyRef.current.scrollHeight;
              }
              setChatData((prev) => mergeChatData(prev, AllChat));
            }
          }
          setHasMore(true);
          setApiLoading(false);
          if (res.data.user) {
            setUser(res.data.user[0]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleScroll = (e) => {
    const { scrollTop } = e.target;
    if (scrollTop < lastScrollTop) {
      if (scrollTop <= 10 && hasMore && NoMoreDataRef.current) {
        setHasMore(false);
        setPage((prev) => prev + 1);
      }
    }
    setLastScrollTop(scrollTop);
  };

  useEffect(() => {
    handleGetMessage(page);
  }, [page]);

  useEffect(() => {
    handleGetChatUser(0, 1);
  }, []);

  const handleGetChatUser = (index, page) => {
    const Userid = secureLocalStorage.getItem("Userid");

    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/chat/all_chat`, {
          id: Userid,
          status: "customer",
          page,
        })
        .then((res) => {
          setLoading(false);
          setChatUser(res.data.chat_list);
          setFilterData(res.data.chat_list);

          if (index === 0 && window.innerWidth > 770) {
            setSelectUser(res.data.chat_list[0]);
            const { receiver_id, sender_id } = res.data.chat_list[0];
            const Index = Userid == sender_id ? receiver_id : sender_id;
            sessionStorage.setItem("Selectid", Index);
            handleGetMessage(1);
          }
        })

        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleSelectUser = (item) => {
    setSelectUser(item);
    setPage(1);
    setHasMore(true);
    NoMoreDataRef.current = true;
    shouldScrollToBottomRef.current = true;

    if (window.innerWidth < 770) {
      setIsShow(true);
    }
  };

  useEffect(() => {
    if (!selectUser) return;

    const Userid = secureLocalStorage.getItem("Userid");
    const Index = Userid == selectUser?.sender_id ? selectUser?.receiver_id : selectUser?.sender_id;
    sessionStorage.setItem("Selectid", String(Index));

    setHasMore(true);
    NoMoreDataRef.current = true;
    shouldScrollToBottomRef.current = true;

    if (page === 1) {
      handleGetMessage(1);
    } else {
      setPage(1);
    }

    setTimeout(() => {
      handleGetChatUser(1, 1);
    }, 1000);
  }, [selectUser]);

  useEffect(() => {
    const Userid = secureLocalStorage.getItem("Userid");
    const activePartnerId = selectUser
      ? (Userid == selectUser.sender_id ? selectUser.receiver_id : selectUser.sender_id)
      : doctorId;

    if (!activePartnerId) return;

    setIsOnline(false);
    setPartnerTyping(false);

    socket.emit("get_online_status", { user_id: String(activePartnerId) });

    const handlePartnerOffline = (data) => {
      if (data && String(data.user_id) === String(activePartnerId)) {
        setIsOnline(false);
      }
    };

    socket.on(`user_offline_${activePartnerId}`, handlePartnerOffline);

    return () => {
      socket.off(`user_offline_${activePartnerId}`, handlePartnerOffline);
    };
  }, [selectUser, doctorId]);

  const handleTypingIndicator = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    const activePartnerId = selectUser
      ? (Userid == selectUser.sender_id ? selectUser.receiver_id : selectUser.sender_id)
      : doctorId;

    if (!Userid || !activePartnerId) return;

    if (!amTypingRef.current) {
      amTypingRef.current = true;
      socket.emit("typing", {
        sender_id: String(Userid),
        receiver_id: String(activePartnerId),
      });
    }

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(() => {
      if (amTypingRef.current) {
        socket.emit("stop_typing", {
          sender_id: String(Userid),
          receiver_id: String(activePartnerId),
        });
        amTypingRef.current = false;
      }
    }, 2000);
  };

  const handleSendMessage = () => {
    if (!selectUser && !doctorId) {
      showToast({ title: t("Please Select User !!"), id: "error" });
      return;
    }

    if (!input) {
      showToast({ title: t("Please Write Message !!"), id: "error" });
      return;
    }

    const Userid = secureLocalStorage.getItem("Userid");

    if (Userid) {
      const RecevierId = selectUser
        ? Userid == selectUser.sender_id
          ? selectUser.receiver_id
          : selectUser.sender_id
        : doctorId;

      const chatRoomId =
        selectUser?.id || sessionStorage.getItem("Appintmentid") || Userid;

      const Data = {
        id: String(chatRoomId),
        sender_id: String(Userid),
        recevier_id: String(doctorId || RecevierId),
        message: input,
        status: "customer",
      };

      axios
        .post(`${ApiBaseUrl}/chat/save_chat`, Data)
        .then((res) => {
          // Message saved successfully
        })
        .catch((error) => {
          console.error("Failed to save chat:", error);
        });

      HandleAddChat();

      setInput("");

      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
      if (amTypingRef.current) {
        socket.emit("stop_typing", {
          sender_id: String(Userid),
          receiver_id: String(doctorId || RecevierId),
        });
        amTypingRef.current = false;
      }
    }
  };

  useEffect(() => {
    const Userid = secureLocalStorage.getItem("Userid");

    const handleNewChat = (msg) => {
      if (Userid == msg?.sender_id) return;

      const container = chatBoxBodyRef.current;
      const isNearBottom = container
        ? container.scrollHeight - container.scrollTop - container.clientHeight < 150
        : true;

      if (isNearBottom) {
        shouldScrollToBottomRef.current = true;
      }

      setChatData((prev) => {
        const todayStr = (!msg.today || msg.today === "0" || typeof msg.today === "object")
          ? new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", year: "numeric", day: "numeric" })
          : String(msg.today);

        const Chat = {
          date: (msg.date && typeof msg.date !== "object") ? String(msg.date) : new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true }),
          message: msg.messages,
          status: 1,
          recevier_id: msg.recevier_id,
          sender_id: msg.sender_id,
        };

        const existingIndex = prev.findIndex((group) => group.date === todayStr);

        if (existingIndex !== -1) {
          const updated = [...prev];
          updated[existingIndex] = {
            ...updated[existingIndex],
            chat: [Chat, ...updated[existingIndex].chat],
          };
          return updated;
        } else {
          return [{ date: todayStr, chat: [Chat] }, ...prev];
        }
      });
    };

    socket.on(`Web_Device_Chat_Reaload${Userid}`, handleNewChat);
    socket.on(`App_Device_Chat_Reaload${Userid}`, handleNewChat);

    return () => {
      socket.off(`Web_Device_Chat_Reaload${Userid}`, handleNewChat);
      socket.off(`App_Device_Chat_Reaload${Userid}`, handleNewChat);
    };
  }, []);

  const HandleAddChat = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    const now = new Date();

    const formattedDate = now.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      year: "numeric",
      day: "numeric",
    });

    const timeString = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    shouldScrollToBottomRef.current = true;
    setChatData((prev) => {
      const existingIndex = prev.findIndex(
        (group) => group.date === formattedDate,
      );

      const Chat = {
        id: Number(Userid),
        date: timeString,
        message: input,
        status: 1,
      };

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          chat: [Chat, ...updated[existingIndex].chat],
        };
        return updated;
      } else {
        return [{ date: formattedDate, chat: [Chat] }, ...prev];
      }
    });
  };

  useEffect(() => {
    const Userid = secureLocalStorage.getItem("Userid");

    const handleNewChat = (msg) => {
      setTimeout(() => {
        handleGetChatUser(1, 1);
      }, 1000);

      const ID = sessionStorage.getItem("Selectid");
      const SenderID = Userid == msg?.sender_id ? msg?.receiver_id : msg?.sender_id;

      if (ID === String(SenderID) && Userid != msg?.sender_id) {
        socket.emit("Web_Chat_Read", {
          sender_id: msg.sender_id,
          recevier_id: msg.recevier_id,
          status: "customer",
        });

        const container = chatBoxBodyRef.current;
        const isNearBottom = container
          ? container.scrollHeight - container.scrollTop - container.clientHeight < 150
          : true;

        if (isNearBottom) {
          shouldScrollToBottomRef.current = true;
        }

        setChatData((prev) => {
          const todayStr = (!msg.today || msg.today === "0" || typeof msg.today === "object")
            ? new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", year: "numeric", day: "numeric" })
            : String(msg.today);

          const Chat = {
            date: (msg.date && typeof msg.date !== "object") ? String(msg.date) : new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true }),
            message: msg.messages,
            status: 2,
            recevier_id: msg.recevier_id,
            sender_id: msg.sender_id,
          };

          const existingIndex = prev.findIndex((group) => group.date === todayStr);

          if (existingIndex !== -1) {
            const updated = [...prev];
            updated[existingIndex] = {
              ...updated[existingIndex],
              chat: [Chat, ...updated[existingIndex].chat],
            };
            return updated;
          } else {
            return [{ date: todayStr, chat: [Chat] }, ...prev];
          }
        });
      }
    };

    const handleOnlineStatus = (data) => {
      const activeId = sessionStorage.getItem("Selectid");
      if (data && String(data.user_id) === String(activeId)) {
        setIsOnline(data.online);
      }
    };

    const handlePartnerTyping = (data) => {
      const activeId = sessionStorage.getItem("Selectid");
      if (data && String(data.sender_id) === String(activeId)) {
        setPartnerTyping(true);
      }
    };

    const handlePartnerStopTyping = (data) => {
      const activeId = sessionStorage.getItem("Selectid");
      if (data && String(data.sender_id) === String(activeId)) {
        setPartnerTyping(false);
      }
    };

    socket.on(`New_Chat_Reaload${Userid}`, handleNewChat);
    socket.on(`online_ack`, handleOnline_ack);
    socket.on(`online_status`, handleOnlineStatus);
    socket.on(`typing_${Userid}`, handlePartnerTyping);
    socket.on(`stop_typing_${Userid}`, handlePartnerStopTyping);

    return () => {
      socket.off(`New_Chat_Reaload${Userid}`, handleNewChat);
      socket.off(`online_ack`, handleOnline_ack);
      socket.off(`online_status`, handleOnlineStatus);
      socket.off(`typing_${Userid}`, handlePartnerTyping);
      socket.off(`stop_typing_${Userid}`, handlePartnerStopTyping);
    };
  }, []);

  useEffect(() => {
    if (chatUser.length >= 1) {
      const FilterData = search
        ? chatUser.filter((item) =>
            item.name.toLowerCase().includes(search.toLowerCase()),
          )
        : chatUser;
      setFilterData(FilterData);
    }
  }, [search]);

  const handleOnline_ack = (data) => {
    console.log("online_ack", data);
    socket.emit("get_online_status", { user_id: data?.user_id });

    const activeId = sessionStorage.getItem("Selectid");
    if (activeId && activeId !== "undefined") {
      socket.emit("get_online_status", { user_id: String(activeId) });
    }
  };

  return (
    <div className="w-full width-container content-wrapper">
      {index !== 1 && loading ? (
        <Loading
          CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white"
          index={0}
        />
      ) : (
        <div className="chat_box">
          {index === 1 ? (
            <div className="border-[1px] border-[#8080803b] rounded-[10px]">
              <div className="flex items-center gap-[15px] p-[10px]">
                <button onClick={() => setShowChat(false)}>
                  <FaArrowLeftLong className="text-[20px]" />
                </button>
                <div className="flex items-center gap-[10px]">
                  <ImageLoad
                    src={ImgBaseUrl + user?.logo}
                    CustomeStyle={
                      "w-[40px] h-[40px] rounded-[100%] object-cover"
                    }
                    alt={user?.name}
                    index={1}
                  />
                  <div className="flex flex-col">
                    <h1 className="font-[500] text-[18px] leading-tight">{user?.name}</h1>
                    <span className={`text-[12px] font-semibold ${partnerTyping ? "text-green-500 italic animate-pulse" : (isOnline ? "text-green-500" : "text-gray-400")}`}>
                      {partnerTyping ? t("Typing...") : (isOnline ? t("Online") : t("Offline"))}
                    </span>
                  </div>
                </div>
              </div>

              <div className="border-t-[1px] border-[#8080803b]"></div>

              <div
                onScroll={handleScroll}
                ref={chatBoxBodyRef}
                className="msg_box scroll-container px-[10px] chat_bg"
              >
                {chatData.length >= 1 ? (
                  chatData
                    .slice()
                    .reverse()
                    .map((dayData, dateIndex) => {
                      return (
                        <div key={dateIndex} className="mb-[5px] mt-[10px]">
                          <h1 className="text-center font-[500] text-[15px]">
                            {dayData.date}
                          </h1>
                          {dayData.chat
                            .slice()
                            .reverse()
                            .map((chatItem, chatIndex) => {
                              return (
                                <div key={chatIndex} className="msg_list mt-[5px]">
                                  <div
                                    className={`message bg-gray-200 ${chatItem.status === 1 ? "sender" : "recevier"}`}
                                  >
                                    <pre className="font-[500] whitespace-pre-wrap">
                                      {chatItem.message}
                                    </pre>
                                    <span className="text-[14px]">{chatItem.date}</span>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      );
                    })
                ) : (
                  <div className="h-[100%] flex items-center justify-center">
                    <h1>Loading.....</h1>
                  </div>
                )}
              </div>

              <div className="p-[10px] flex items-center gap-[10px]">
                <input
                  value={input}
                  onChange={(e) => {
                    setInput(e.target.value);
                    handleTypingIndicator();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSendMessage();
                    }
                  }}
                  type="text"
                  className="w-[100%] border-[2px] border-[#8080803b] rounded-[10px] py-[8px] px-[10px] font-[500] focus-within:border-[#4038FF]"
                  placeholder={t("Say Something...")}
                />
                <button
                  onClick={handleSendMessage}
                  className="bg-[#4038FF] rounded-[10px] p-[10px]"
                >
                  <IoMdSend className="text-[20px] text-white" />
                </button>
              </div>
            </div>
          ) : (
            <div className="main_box">
              <div className={`user_box bg-gray-100 ${isShow && "close"}`}>
                <div className="flex items-center">
                  <input
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-[100%] border-[1px] border-[#8080803b] rounded-[10px] py-[8px] px-[10px] focus-within:outline-[#4038FF]"
                    placeholder={t("Search...")}
                  />
                  <IoSearchOutline className="-ms-[27px]" />
                </div>
                <div className="mt-[10px] h-[100%] scroll-container pb-[43px]">
                  {filterData.length >= 1 ? (
                    filterData.map((item, index) => {
                      return (
                        <div
                          onClick={() => HandleSelectUser(item)}
                          key={index}
                          className={`w-[100%] py-[10px] px-[8px] flex items-center gap-[10px] cursor-pointer ${index !== 0 && "border-t-[1px] border-gray-400"}`}
                        >
                          <div className="w-[50px] h-[50px] min-w-[50px] rounded-[100%] overflow-hidden">
                            <ImageLoad
                              src={ImgBaseUrl + item?.logo}
                              CustomeStyle={"w-[100%] h-[100%] object-cover"}
                              alt={item?.name}
                              index={1}
                            />
                          </div>
                          <div className="w-[70%] max-_770_:w-[90%] overflow-hidden overflow-ellipsis">
                            <h1 className="whitespace-nowrap overflow-hidden overflow-ellipsis">
                              {item.name}
                            </h1>
                            <span className="whitespace-nowrap overflow-ellipsis text-gray-600">
                              {item.message}
                            </span>
                          </div>
                          {item.status === "0" ? (
                            <span>{item.date}</span>
                          ) : (
                            <div className="w-[8px] h-[8px] rounded-[50px] bg-[#4038FF]"></div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className="h-full flex items-center justify-center">
                      <h1>{t("No Doctors found !!")}</h1>
                    </div>
                  )}
                </div>
              </div>

              <div
                ref={ClassRef}
                className={`user_chat ${isShow ? "chat_open" : ""}`}
              >
                <div className="select_box mb-[5px]">
                  <div className="flex items-center gap-[10px]">
                    {selectUser && (
                      <button
                        className="chat_icon"
                        onClick={() => setIsShow(false)}
                      >
                        <IoIosArrowBack className="text-[20px]" />
                      </button>
                    )}
                    {selectUser && (
                      <img
                        src={ImgBaseUrl + selectUser?.logo}
                        className="user_img"
                        alt=""
                      />
                    )}
                    <div className="flex flex-col">
                      <h1 className="font-[500] text-[17px] leading-tight">
                        {selectUser ? selectUser?.name : t("Select User")}
                      </h1>
                      {selectUser && (
                        <span className={`text-[12px] font-semibold ${partnerTyping ? "text-green-500 italic animate-pulse" : (isOnline ? "text-green-500" : "text-gray-400")}`}>
                          {partnerTyping ? t("Typing...") : (isOnline ? t("Online") : t("Offline"))}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  onScroll={handleScroll}
                  ref={chatBoxBodyRef}
                  className="h-full scroll-container px-2.5 chat_bg"
                >
                  {apiloading ? (
                    <Loading CustomeStyle="h-full flex items-center justify-center" />
                  ) : selectUser && chatData.length > 0 ? (
                    chatData
                      .slice()
                      .reverse()
                      .map((dayData, dateIndex) => (
                        <div key={dateIndex} className="mb-1.5 mt-2.5">
                          <h1 className="text-center font-medium text-sm">
                            {dayData.date}
                          </h1>
                          {dayData.chat
                            .slice()
                            .reverse()
                            .map((chatItem, chatIndex) => (
                              <div key={chatIndex} className="msg_list mt-1.5">
                                <div
                                  className={`message bg-gray-100 ${
                                    chatItem.status === 1
                                      ? "sender"
                                      : "recevier"
                                  }`}
                                >
                                  <pre className="font-medium whitespace-pre-wrap">
                                    {chatItem.message}
                                  </pre>
                                  <span className="text-sm">
                                    {chatItem.date}
                                  </span>
                                </div>
                              </div>
                            ))}
                        </div>
                      ))
                  ) : (
                    <div className="h-full flex items-center justify-center">
                      <h1>{t("No messages found !!")}</h1>
                    </div>
                  )}
                </div>

                <div className="send_box mt-[5px]">
                  <input
                    value={input}
                    onChange={(e) => {
                      setInput(e.target.value);
                      handleTypingIndicator();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSendMessage();
                      }
                    }}
                    type="text"
                    className="w-[100%] border-[2px] border-[#8080803b] rounded-[10px] py-[8px] px-[10px] font-[500] focus-within:border-[#4038FF]"
                    placeholder={t("Say Something...")}
                  />
                  <button
                    onClick={handleSendMessage}
                    className="bg-[#4038FF] rounded-[10px] p-[10px]"
                  >
                    <IoMdSend className="text-[20px] text-white" />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Chat;
/* jshint ignore:end */
